import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { gameConfigStore } from '@pascal/pascal-core/shared/core/store';
import { observer } from 'mobx-react-lite';
import { liveConnection } from './liveConnection';
import { gameLiveConnection } from '../services';

let isFirst = true;
export const SocketConnection = observer(({ children }) => {
  const { pathname } = useLocation();
  const { gameTypeId, isSkipLobby } = gameConfigStore;

  useEffect(() => {
    liveConnection.handleSocketInit(pathname).then((connectionData) => {
      liveConnection.connectionInitCallback(connectionData);
    });
  }, [pathname]);

  useEffect(() => {
    if (!isFirst && isSkipLobby) {
      gameLiveConnection.sendGameGetInitialState(false).then(() => {});
    }
    isFirst = false;
  }, [gameTypeId, isSkipLobby]);

  return children;
});
